'use client';

import { type ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

type FadeInWhenVisibleProps = {
  children: ReactNode;
  /** Stagger delay in seconds (e.g. 0.08 per grid item). */
  delay?: number;
  className?: string;
  /**
   * Stretch to fill a parent flex/grid cell. Parent `Grid` item should use
   * `sx={{ display: 'flex' }}` (or equivalent) so row heights align.
   */
  fillParent?: boolean;
};

export function FadeInWhenVisible({
  children,
  delay = 0,
  className,
  fillParent = false,
}: FadeInWhenVisibleProps) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      className={className}
      initial={reduceMotion ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
      style={
        fillParent
          ? {
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }
          : undefined
      }
      transition={{ duration: 0.45, delay, ease: [0.22, 1, 0.36, 1] }}
      viewport={{ once: true, margin: '-72px' }}
      whileInView={{ opacity: 1, y: 0 }}
    >
      {children}
    </motion.div>
  );
}
